import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    eyebrow: string
    title: ReactNode
    description?: string
    align?: 'left' | 'center'
    tone?: 'light' | 'dark'
    id?: string
    className?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({
    eyebrow,
    title,
    description,
    align = 'left',
    tone = 'light',
    id,
    className
}): ReactNode => {
    const dark = tone === 'dark'

    return (
        <div className={cn('reveal max-w-2xl', align === 'center' && 'mx-auto text-center', className)}>
            <p
                className={cn(
                    'inline-flex items-center gap-3 text-[0.7rem] uppercase tracking-[0.32em]',
                    dark ? 'text-champagne/80' : 'text-gold-deep'
                )}
            >
                <span aria-hidden='true' className='h-px w-8 bg-current opacity-60' />
                {eyebrow}
            </p>

            <h2
                id={id}
                className={cn(
                    'mt-6 text-balance font-heading text-[clamp(2.6rem,5.2vw,4.6rem)] font-light leading-[1.02] tracking-[-0.01em]',
                    dark ? 'text-ivory' : 'text-espresso'
                )}
            >
                {title}
            </h2>

            {description && (
                <p
                    className={cn(
                        'mt-6 text-lg leading-relaxed',
                        align === 'center' && 'mx-auto max-w-xl',
                        dark ? 'text-ivory/65' : 'text-muted-foreground'
                    )}
                >
                    {description}
                </p>
            )}
        </div>
    )
}
